define('utils/group',{
    TYPE_OPERATOR: 0,
    TYPE_DEVICE_MAKER: 1,
    TYPE_OTHER: 2,
    TYPE_TAP_MAKER: 3,
    TYPE_PRODUCT_MAKER: 4,
    TYPE_VIRTUAL_OPERATOR: 5,
    TYPE_PARTNERS: 6,
    TYPE_NIP: 7,
    TYPE_DIST: 8,
    TYPE_CHANNEL: 9
});

